import {
    BODY_SM_SM_MEDIUM_STYLES,
    BODY_SM_SM_STYLES,
    BODY_XS_XS_MEDIUM_STYLES,
    BODY_XS_XS_STYLES,
} from '@constants/text.ts';
import styled from 'styled-components';

export const CustomCategoryFilterWrapper = styled.div<{ $isFixedWidth?: boolean }>`
    display: flex;
    flex-direction: column;
    padding: ${({ $isFixedWidth }) => ($isFixedWidth ? 'var(--spacing-xs, 8px)' : '0')};
    width: ${({ $isFixedWidth }) => ($isFixedWidth ? '280px' : '100%')};

    .ant-input-affix-wrapper {
        margin-bottom: 8px;
    }

    .ant-input {
        color: var(--colors-text-filled, #2f3449);
        ${BODY_SM_SM_STYLES};
        font-size: 14px !important;
    }

    .ant-input::placeholder {
        color: var(--colors-text-on-disabled, #70768d);
    }
`;

export const LevelLabel = styled.span`
    ${BODY_XS_XS_MEDIUM_STYLES};
`;

export const LevelLabelRegular = styled(LevelLabel)`
    color: var(--colors-text-body, #50566e);
`;

export const LevelLabelLight = styled(LevelLabel)`
    color: var(--colors-text-on-disabled, #70768d);
`;

export const LabelItemsSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: var(--spacing-xs, 8px);
`;

export const LabelWrapper = styled.span<{ $isSelected: boolean }>`
    & span.ant-tag {
        margin-right: 8px;
        margin-bottom: 8px;
        cursor: pointer;

        background: ${({ $isSelected }) =>
            $isSelected ? 'var(--colors-border-action, #2171C6)' : 'var(--neutral-100, #f9fafb)'};

        color: ${({ $isSelected }) =>
            $isSelected ? 'var(--colors-text-on-action, #FFF)' : 'var(--colors-text-body, #50566E)'};

        border: ${({ $isSelected }) =>
            $isSelected
                ? 'var(--border-width-sm-1, 1px) solid var(--colors-border-information, #2171C6)'
                : 'var(--border-width-sm-1, 1px) solid var(--colors-border-default, #B4B8BF)'};
    }
`;

export const ButtonsWrapper = styled.div`
    display: flex;
    gap: 10px;
    margin-top: 8px;
    margin-bottom: 16px;

    button {
        width: 100%;
        color: var(--colors-text-action, #2171c6);
        ${BODY_SM_SM_MEDIUM_STYLES};
        font-size: 14px !important;
    }
`;

export const ValuesGroupSection = styled.div`
    display: flex;
    flex-direction: column;
`;

export const ValueGroupHeader = styled.div`
    color: var(--colors-text-on-disabled, #70768d);
    ${BODY_SM_SM_STYLES};
    font-size: 14px !important;
    padding: var(--spacing-2xs, 4px) 10px;
    border-radius: var(--border-radius-xs_4, 4px);
    background: var(--neutral-150, #f1f4f8);
`;

export const SubitemWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const CheckboxLabelWrapper = styled.div`
    margin-left: 24px;
    label {
        padding: var(--spacing-2xs, 4px) 0;
        span {
            color: var(--colors-text-body, #50566e);
            ${BODY_SM_SM_STYLES};
        }
    }
    .ant-checkbox {
        .ant-checkbox-inner {
            width: 16px;
            height: 16px;
            border-radius: 5px;
            border: var(--border-width-sm_1, 1px) solid var(--colors-border-default, #b4b8bf);
        }
    }
    .ant-checkbox-checked {
        .ant-checkbox-inner::after {
            left: 6px;
            top: 3px;
            width: 4px;
            height: 8px;
        }
    }
`;

export const SubItemCategoryLabel = styled.div`
    color: var(--colors-text-on-disabled, #70768d);
    font-size: 12px !important;
    ${BODY_XS_XS_STYLES};
`;

const SelectedCountSection = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: var(--spacing-xs, 8px) 10px;
    border-top: 1px solid var(--colors-border-disabled, #d3dbe5);
    border-bottom: 1px solid var(--colors-border-disabled, #d3dbe5);
    ${BODY_SM_SM_STYLES};
    font-size: 14px !important;
    color: var(--colors-text-on-disabled, #70768d);
    margin: var(--spacing-xs, 8px) 0;

    div {
        font-size: 14px !important;
    }
`;

export const SelectedCountSectionVessels = styled(SelectedCountSection)`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const SelectedCountSectionRanks = styled(SelectedCountSection)`
    display: flex;
    align-items: flex-start;
    flex-direction: column;
`;

export const EmptyStateWrapper = styled.div`
    display: flex;
    height: 132px;
    padding: var(--spacing-md, 24px) 0;
    flex-direction: column;
    align-items: center;
    gap: var(--spacing-2xs, 4px);
    align-self: stretch;
`;

export const EmptyStateText = styled.div`
    color: var(--colors-text-body, #50566e);
    text-align: center;
    font-size: 14px !important;
    ${BODY_SM_SM_STYLES};
`;

export const SubItemsSection = styled.div`
    max-height: 300px;
    overflow-y: auto;
    scrollbar-width: thin;
    scrollbar-color: var(--colors-surface-action, #2171c6) transparent;
`;

export const WarningText = styled.div`
    color: var(--colors-text-warning, #ab7b09);
    ${BODY_SM_SM_STYLES};
    font-size: 14px !important;
    margin-bottom: 10px;
`;
